export enum LogLevel {
    DEBUG = 0,
    INFO = 1,
    WARN = 2,
    ERROR = 3
}

export class Logger {
    private level: LogLevel;
    private prefix: string;

    constructor(level: LogLevel = LogLevel.INFO, prefix: string = 'App') {
        this.level = level;
        this.prefix = prefix;
    }

    public setLevel(level: LogLevel): void {
        this.level = level;
    }

    public debug(message: string, ...args: any[]): void {
        this.log(LogLevel.DEBUG, message, args);
    }

    public info(message: string, ...args: any[]): void {
        this.log(LogLevel.INFO, message, args);
    }

    public warn(message: string, ...args: any[]): void {
        this.log(LogLevel.WARN, message, args);
    }

    public error(message: string, ...args: any[]): void {
        this.log(LogLevel.ERROR, message, args);
    }

    private log(level: LogLevel, message: string, args: any[]): void {
        if (level < this.level) {
            return;
        }

        const timestamp = new Date().toISOString();
        const formattedMessage = `[GDS][${timestamp}] [${this.prefix}] ${message}`;

        switch (level) {
            case LogLevel.DEBUG:
                console.debug(formattedMessage, ...args);
                break;
            case LogLevel.INFO:
                console.info(formattedMessage, ...args);
                break;
            case LogLevel.WARN:
                console.warn(formattedMessage, ...args);
                break;
            case LogLevel.ERROR:
                console.error(formattedMessage, ...args);
                break;
        }
    }
}
